import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import AppListHome from "../../components/ui/AppListHome";
import BottomNavigation from "../../components/ui/BottomNavigation";
import Header from "../../components/ui/Header";
import { usePostHome } from "../../hooks/usePostHome";
import AppListHomeSkeleton from "../../components/ui/AppListHomeSkeleton";

const GamesPage: React.FC = () => {
  const [selectedFilter, setSelectedFilter] = useState<{
    id: number;
    type: string;
    label: string;
  }>(); // State for selected filter

  const { dashboardQuery } = usePostHome("game", 
    selectedFilter?.type && selectedFilter?.id 
      ? { filter: `${selectedFilter.type}__${selectedFilter.id}` } 
      : undefined
  );
  const { data, isLoading } = dashboardQuery;
  const [tabs, setTabs] = useState<{
    id: number;
    type: string;
    label: string;
  }[]>([]); // State for tabs

  useEffect(() => {
    if (data?.modules) {
      const typeTabs = data.modules.find((module: any) => module.type === "type_tabs");
      if (typeTabs && typeTabs.items) {
        const newTabs: any[] = typeTabs.items.map((item: any) => ({
          id: item.id,
          type: item.type,
          label: item.name,
        })) || []; // Extract tabs from the modules
        setTabs(newTabs);
        console.log("Loaded tabs:", newTabs);
      }
    }
  }, [data]);

  const handleTabClick = (tab:any) => {
    setSelectedFilter(tab);
  };

  const filteredModules = data?.modules?.filter((module: any) =>
    selectedFilter ? module.filterKey === selectedFilter : true
  ); // Filter modules based on selectedFilter

  const typeTabsModules = data?.modules?.filter(
    (module: any) => module.type === "type_tabs"
  ); // Filter modules with type "type_tabs"

  console.log("Filtered Modules:", tabs);
  return (
    <div>
      <Header tabs={tabs} onTabClick={handleTabClick} selectedFilter={selectedFilter} />

      {/* Add padding to avoid content overlap */}
      <div  >
        {/* Movies List Section */}
        <div className="section-movies">
          {isLoading ? (
          <AppListHomeSkeleton />
          ) : (
            filteredModules && <AppListHome data={filteredModules} />
          )}
        </div>

        {/* Type Tabs Modules Section */}
        {typeTabsModules && (
          <div className="type-tabs-modules">
             <AppListHome data={typeTabsModules} />
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      {/* <BottomNavigation /> */}
    </div>
  );
};

export default GamesPage;
